<template>
  <el-dialog
    :title="title"
    width="800px"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    @closed="closeAfter"
    :close-on-click-modal="false"
  >
    <el-tabs v-model="activeName">
      <!-- 基本信息 -->
      <el-tab-pane :label="$t('pages.equipment.text139')" name="basic">
        <BasicModule
          :activeName="activeName"
          :options="options"
          :params="params"
          @mergeParams="mergeParams"
          :moduleState="moduleState"
        />
      </el-tab-pane>
      <!-- 规格信息 -->
      <el-tab-pane :label="$t('pages.equipment.text140')" name="config">
        <ConfigModule
          :activeName="activeName"
          @mergeParams="mergeParams"
          :params="params"
          :moduleState="moduleState"
        />
      </el-tab-pane>
      <!-- 使用指南 -->
      <el-tab-pane :label="$t('pages.equipment.text141')" name="guide">
        <GuideModule
          :activeName="activeName"
          @mergeParams="mergeParams"
          :params="params"
          :moduleState="moduleState"
        />
      </el-tab-pane>
    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{
        moduleState == 2 ? $t("button.close") : $t("button.cancel")
      }}</el-button>
      <el-button type="primary" @click="submitForm" v-if="moduleState != 2">{{
        $t("button.determine")
      }}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import BasicModule from "./basicModule.vue";
import ConfigModule from "./configModule.vue";
import GuideModule from "./guideModule.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      title: this.$t("pages.equipment.text142"),
      activeName: null,
      params: {
        belongCategoryId: "", //车辆类别id
        belongCustomerId: "", //客户id
        bikeCtrlType: "", //车辆控制方式，1 4g+蓝牙 2 纯蓝牙 3 纯4g
        bikeTypeCode: "", //车辆型号代码
        bikeTypeFormatInfo: [
          {
            color: "",
            wheelSize: "",
            endurance: "",
          },
        ], //规格信息
        bikeTypeImageName: "", //车辆型号图片名称
        bikeTypeImagePath: "", //车辆型号图片链接
        bikeTypeName: "", //车辆型号名称
        richTextContent: "", //	富文本内容
        richTextTittle: "", //富文本标题
        lowPowerPercent: 1, //低电阈值
        guideLink: "",
        guideFlag: 0,
        protocol: null, //故障协议
      },
    };
  },
  components: {
    BasicModule,
    ConfigModule,
    GuideModule,
  },
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        // console.log(this.currentEquipment);
        if (this.moduleState == 0) {
          this.title = this.$t("pages.equipment.text142");
        } else if (this.moduleState == 1) {
          this.title = this.$t("pages.equipment.text143");
          this.params = {
            belongCategoryId: this.currentEquipment.belongCategoryId, //车辆类别id
            belongCustomerId: "", //客户id
            bikeCtrlType: this.currentEquipment.bikeCtrlType, //车辆控制方式，1 4g+蓝牙 2 纯蓝牙 3 纯4g
            bikeTypeCode: this.currentEquipment.bikeTypeCode, //车辆型号代码
            bikeTypeFormatInfo: this.currentEquipment.bikeTypeFormatInfo, //规格信息
            bikeTypeImageName: this.currentEquipment.bikeTypeImageName, //车辆型号图片名称
            bikeTypeImagePath: this.currentEquipment.bikeTypeImagePath, //车辆型号图片链接
            bikeTypeName: this.currentEquipment.bikeTypeName, //车辆型号名称
            richTextContent: this.currentEquipment.richTextContent, //	富文本内容
            richTextTittle: this.currentEquipment.richTextTittle, //富文本标题
            lowPowerPercent: this.currentEquipment.lowPowerPercent, //低电阈值
            guideLink: this.currentEquipment.guideLink,
            guideFlag: this.currentEquipment.guideFlag,
            protocol: this.currentEquipment.protocol,
            id: this.currentEquipment.id,
          };
        } else {
          this.title = this.$t("pages.equipment.text144");
          this.params = {
            belongCategoryId: this.currentEquipment.belongCategoryId, //车辆类别id
            belongCustomerId: "", //客户id
            bikeCtrlType: this.currentEquipment.bikeCtrlType, //车辆控制方式，1 4g+蓝牙 2 纯蓝牙 3 纯4g
            bikeTypeCode: this.currentEquipment.bikeTypeCode, //车辆型号代码
            bikeTypeFormatInfo: this.currentEquipment.bikeTypeFormatInfo, //规格信息
            bikeTypeImageName: this.currentEquipment.bikeTypeImageName, //车辆型号图片名称
            bikeTypeImagePath: this.currentEquipment.bikeTypeImagePath, //车辆型号图片链接
            bikeTypeName: this.currentEquipment.bikeTypeName, //车辆型号名称
            richTextContent: this.currentEquipment.richTextContent, //	富文本内容
            richTextTittle: this.currentEquipment.richTextTittle, //富文本标题
            lowPowerPercent: this.currentEquipment.lowPowerPercent, //低电阈值
            id: this.currentEquipment.id,
            guideLink: this.currentEquipment.guideLink,
            guideFlag: this.currentEquipment.guideFlag,
            protocol: this.currentEquipment.protocol,
          };
        }
        this.activeName = "basic";
      }
    },
  },
  computed: {
    ...mapState(["platformData"]),
  },
  props: ["dialogVisible", "options", "moduleState", "currentEquipment"],
  methods: {
    closeAfter() {
      this.activeName = null;
    },
    // 取消
    handleClose() {
      this.params = {
        belongCategoryId: "", //车辆类别id
        belongCustomerId: "", //客户id
        bikeCtrlType: "", //车辆控制方式，1 4g+蓝牙 2 纯蓝牙 3 纯4g
        bikeTypeCode: "", //车辆型号代码
        bikeTypeFormatInfo: [], //规格信息
        bikeTypeImageName: "", //车辆型号图片名称
        bikeTypeImagePath: null, //车辆型号图片链接
        bikeTypeName: "", //车辆型号名称
        richTextContent: "", //	富文本内容
        richTextTittle: "", //富文本标题
        lowPowerPercent: 1, //低电阈值
        id: "",
        guideLink: "",
        guideFlag: 0,
        protocol: null,
      };
      this.$emit("dialogClose");
    },
    //合并参数
    mergeParams(e) {
      this.params = { ...this.params, ...e };
    },

    // 确定
    submitForm() {
      setTimeout(() => {
        this.params.belongCustomerId = this.platformData.id;
        let arr = this.params.bikeTypeFormatInfo.filter((item) => {
          return item.color || item.wheelSize || item.endurance;
        });
        console.log(this.params);
        if (arr.length > 0) {
          for (let i in arr) {
            if (arr[i].color.length > 15) {
              return this.$message.error(this.$t("pages.equipment.text145"));
            }
            if (!/^[0-9]*$/.test(arr[i].wheelSize)) {
              return this.$message.error(this.$t("pages.equipment.text146"));
            }
            if (arr[i].wheelSize.length > 3) {
              return this.$message.error(this.$t("pages.equipment.text147"));
            }
            if (!/^[0-9]*$/.test(arr[i].endurance)) {
              return this.$message.error(this.$t("pages.equipment.text148"));
            }
            if (arr[i].endurance.length > 3) {
              return this.$message.error(this.$t("pages.equipment.text149"));
            }
          }
        }

        this.params.bikeTypeFormatInfo = arr;
        if (!this.params.belongCategoryId) {
          return this.$message.error(this.$t("pages.equipment.text150"));
        }
        if (!this.params.bikeCtrlType) {
          return this.$message.error(this.$t("pages.equipment.text151"));
        }
        if (!this.params.bikeTypeCode) {
          return this.$message.error(this.$t("pages.equipment.text152"));
        }
        if (!this.params.bikeTypeImagePath) {
          return this.$message.error(this.$t("pages.equipment.text153"));
        }
        if (!this.params.bikeTypeName) {
          return this.$message.error(this.$t("pages.equipment.text154"));
        }
        if (!this.params.richTextContent && !this.params.guideLink) {
          return this.$message.error(this.$t("pages.equipment.text155"));
        }
        if (!this.params.richTextTittle && !this.params.guideLink) {
          return this.$message.error(this.$t("pages.equipment.text156"));
        }
        if (this.params.guideLink) {
          let t = new RegExp("[\\u4E00-\\u9FFF]+", "g");
          if (this.params.guideLink.indexOf(" ") != -1) {
            return this.$message.error(this.$t("pages.equipment.text258"));
          } else if (t.test(this.params.guideLink)) {
            return this.$message.error(this.$t("pages.equipment.text259"));
          }
        }
        if (!this.params.lowPowerPercent) {
          return this.$message.error(this.$t("pages.equipment.text157"));
        }

        if (this.moduleState == 0) {
          this.request.equipmentModeAdd(this.params).then(() => {
            this.$message.success(this.$t("public.text8"));
            this.$emit("equipmentModeList");
            this.handleClose();
          });
        } else {
          this.request.equipmentModeEdit(this.params).then(() => {
            this.$message.success(this.$t("public.text9"));
            this.$emit("equipmentModeList");
            this.handleClose();
          });
        }
      }, 500);
    },
  },
};
</script>

<style scoped>
.from-body {
  box-sizing: border-box;
  width: 70%;
}
.from-bodys {
  box-sizing: border-box;
  width: 90%;
}
.apiContent {
  width: 54%;
}
.richcontent {
  display: flex;
}
.num {
  display: flex;
  flex-direction: column;
}
.prompt {
  margin-left: 100px;
}
.title {
  width: 60px;
  margin-right: 20px;
  margin-left: 20px;
}
</style>